<div class="w-1/4 p-4">
    <form [formGroup]="form" class="flex flex-col gap-4">
        <mat-form-field appearance="outline">
            <mat-label>Select Date Range</mat-label>
            <mat-date-range-input
                (focusin)="picker.open()"
                [rangePicker]="picker"
                [max]="maxDate"
            >
                <input
                    matStartDate
                    (focus)="picker.open()"
                    [formControl]="form.controls.startDate"
                    placeholder="Start Date"
                />
                <input
                    matEndDate
                    (focus)="picker.open()"
                    [formControl]="form.controls.endDate"
                    placeholder="End Date"
                />
            </mat-date-range-input>
            <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-hint
                align="end"
                class="text-primary-700 font-medium cursor-pointer text-sm"
                (click)="clearDates()"
            >
                Clear Dates
            </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Export Type</mat-label>
            <mat-select [formControl]="form.controls.reportType" required>
                @for (
                    accountingReviewReportExportTypeDropdownOption of accountingReviewReportExportTypeDropdownOptions;
                    track accountingReviewReportExportTypeDropdownOption.value
                ) {
                    <mat-option
                        [value]="
                            accountingReviewReportExportTypeDropdownOption.value
                        "
                    >
                        {{
                            accountingReviewReportExportTypeDropdownOption.label
                        }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <button
            type="button"
            mat-flat-button
            color="primary"
            [disabled]="form.invalid"
            (click)="onExport()"
        >
            Export Report
        </button>
    </form>
</div>
